import { useNavigate, useLocation } from 'react-router-dom';
import { Zap, LayoutDashboard, Target, FileText, Trophy, User, Users, MessageCircle, BarChart3, Gift } from 'lucide-react';

function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/roleplay', icon: Target, label: 'Roleplay' },
    { path: '/scripts', icon: FileText, label: 'Scripts' },
    { path: '/challenges', icon: Trophy, label: 'Challenges' },
    { path: '/leaderboard', icon: Users, label: 'Leaderboard' },
    { path: '/community', icon: MessageCircle, label: 'Community' },
    { path: '/referrals', icon: Gift, label: 'Refer & Earn' },
    { path: '/analytics', icon: BarChart3, label: 'Analytics' },
    { path: '/profile', icon: User, label: 'Profile' }
  ];

  return (
    <nav className="glass-effect border-b border-white/10 sticky top-0 z-50" data-testid="main-navigation">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-center h-16">
          <div 
            className="flex items-center gap-2 cursor-pointer" 
            onClick={() => navigate('/dashboard')}
            data-testid="logo"
          >
            <Zap className="text-green-500 w-8 h-8" />
            <span className="font-['Outfit'] text-xl font-bold">Negotiation Ninja AI</span>
          </div>

          <div className="flex gap-2">
            {navItems.map(item => (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all ${
                  isActive(item.path) 
                    ? 'bg-green-500/20 text-green-400 border border-green-500/40' 
                    : 'text-gray-400 hover:bg-white/5 hover:text-white'
                }`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <item.icon className="w-5 h-5" />
                <span className="hidden md:inline font-semibold">{item.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;